import React, { ReactElement } from 'react';
import { makeStyles, Theme } from '@material-ui/core';
import { displayAsPrice } from './helpers';
import { Product } from '../services/typings';

const NO_INFO_MESSAGE = 'Aucun';
const IMAGE_SIZE = 186;

interface Props {
  product: Product;
}

const useStyles = makeStyles((theme: Theme) => ({
  container: {
    display: 'flex',
    flexDirection: 'row',
    padding: theme.spacing(1),
  },
  sectionContainer: {
    flex: 1,
    flexDirection: 'column',
    margin: theme.spacing(2),
  },
  title: {
    fontSize: '18px',
    marginBottom: theme.spacing(1),
  },
  content: {
    fontSize: '12px',
    lineHeight: '20px',
    marginBottom: theme.spacing(1),
  },
  imageContainer: {
    width: IMAGE_SIZE,
    height: IMAGE_SIZE,
  },
  image: {
    width: '100%',
    height: '100%',
  },
}));

const WarehouseItemTooltip = ({
  product: { image, name, allergens, ingredients, price },
}: Props): ReactElement => {
  const classes = useStyles();

  return (
    <div className={classes.container}>
      {image && (
        <div className={classes.imageContainer}>
          <img
            className={classes.image}
            src={image}
            alt={name}
            width={IMAGE_SIZE}
            height={IMAGE_SIZE}
          />
        </div>
      )}
      <div className={classes.sectionContainer}>
        <div className={classes.title}>{name}</div>
        <div className={classes.content}>Ingrédients : {ingredients || NO_INFO_MESSAGE}</div>
        <div className={classes.content}>Allergènes : {allergens || NO_INFO_MESSAGE}</div>
        <div className={classes.content}>Prix : {displayAsPrice(price.amount)}</div>
      </div>
    </div>
  );
};

export default WarehouseItemTooltip;
